'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _rollbar = require('./rollbar');

var _rollbar2 = _interopRequireDefault(_rollbar);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var HttpErrorHandler = function () {
    function HttpErrorHandler() {
        _classCallCheck(this, HttpErrorHandler);
    }

    _createClass(HttpErrorHandler, null, [{
        key: 'setup',
        value: function setup(callback) {
            // More callbacks can be added if necessary in the future
            if (!callback || !callback.onConnectionFail || !callback.onAPIFail) {
                console.warn('You must pass callback parameter to AppBootstrap.setup, with onConnectionFail and onAPIFail methods.');
            } else {
                HttpErrorHandler.callback['onAPIFail'] = callback.onAPIFail;
                HttpErrorHandler.callback['onConnectionFail'] = callback.onConnectionFail;
                HttpErrorHandler.callback['errorCatcher'] = callback.errorCatcher; // Optional
            }
        }
    }, {
        key: 'handle',
        value: function handle(error) {
            var errorObj = { payload: error }; // Keep the original error on payload

            // TypeError can have different meanings, so check the message
            if (error.name !== 'TypeError') {
                errorObj.name = error.name;
                errorObj.message = error.message;
            } else {
                errorObj.name = error.message;
                errorObj.message = error.name;
            }
            errorObj.stack = new Error().stack;
            errorObj.level = 'error'; // Default level

            var handler = errorLibrary[errorObj.name];
            if (handler) {
                if (handler.message) {
                    errorObj.message = handler.message;
                }
                if (handler.callback && HttpErrorHandler.callback[handler.callback]) {
                    HttpErrorHandler.callback[handler.callback](errorObj);
                }
                if (handler.level === null) {
                    return errorObj;
                } else {
                    errorObj.level = handler.level;
                }
            }

            // Send to rollbar or defined errorCatcher
            if (this.callback.errorCatcher) {
                this.callback.errorCatcher(errorObj);
            } else {
                _rollbar2.default[errorObj.level](errorObj);
            }
            return errorObj;
        }
    }, {
        key: 'mount',
        value: function mount(response) {
            var error = {};
            error.name = response.status;
            error.message = response.text() || 'Error with no message';
            throw error;
        }
    }]);

    return HttpErrorHandler;
}();

// Http errors that need a special handle.


var errorLibrary = {
    '400': {
        level: null //Don't send to rollbar
    },
    '404': {
        level: 'error', // Send to rollbar as error
        message: 'Não encontrado.', // Change de message to the view
        callback: 'onAPIFail' // Call onAPIFail callback
    },
    '500': {
        level: 'warning',
        message: 'Falha do servidor. Tente novamente.',
        callback: 'onConnectionFail'
    },
    '503': {
        level: 'warning',
        message: 'Falha do servidor. Tente novamente.',
        callback: 'onConnectionFail'
    },
    'ValidatorError': {
        level: 'critical',
        message: 'Um campo foi preenchido com valor não permitido.',
        callback: 'onAPIFail'
    },
    'MongoError': {
        level: 'warning',
        message: 'Falha de comunicação com o servidor.',
        callback: 'onConnectionFail'
    },
    'Failed to fetch': {
        level: 'warning',
        message: 'Falha de comunicação com o servidor.',
        callback: 'onConnectionFail'
    },
    'FetchError': {
        level: 'warning',
        message: 'Falha de comunicação com o servidor.',
        callback: 'onConnectionFail'
    }
};

HttpErrorHandler.callback = {};

exports.default = HttpErrorHandler;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@app-masters/js-lib/dist/httpErrorHandler.js
// module id = 334
// module chunks = 0